import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../../firebase";
import {
  collection,
  getDocs,
  query,
  orderBy,
  deleteDoc,
  doc,
} from "firebase/firestore";
import Modal from "../../../components/Modal/Modal";
import styles from "./CompanyList.module.css";

const CompanyList = () => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  // Firestore에서 회사 데이터 가져오기
  const fetchCompanies = async () => {
    try {
      const q = query(
        collection(db, "companies"),
        orderBy("createdAt", "desc")
      );
      const querySnapshot = await getDocs(q);
      const companyData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCompanies(companyData);
    } catch (error) {
      console.error("회사 데이터 불러오기 실패:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  // 삭제 버튼 클릭 시 모달 열기
  const handleDeleteClick = (company) => {
    setSelectedCompany(company);
    setIsModalOpen(true);
  };

  // Firestore에서 회사 삭제
  const handleDeleteConfirm = async () => {
    if (!selectedCompany) return;
    try {
      await deleteDoc(doc(db, "companies", selectedCompany.id));
      fetchCompanies();
      setIsModalOpen(false);
    } catch (error) {
      console.error("🔥 Firestore 삭제 실패:", error);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>회사 목록</h2>

      <button
        className={styles.addButton}
        onClick={() => navigate("/admin/companies/add")}
      >
        회사 등록
      </button>

      <div className={styles.companyList}>
        {companies.length > 0 ? (
          companies.map((company) => (
            <div
              key={company.id}
              className={styles.companyCard}
              onClick={() => navigate(`/admin/companies/${company.id}`)}
            >
              <div
                className={styles.deleteButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteClick(company);
                }}
              >
                ❌
              </div>
              <img
                src={company.logo}
                alt={company.name}
                className={styles.companyLogo}
              />
              <h3>{company.name}</h3>
              <p>📍 {company.address}</p>
              <p>📞 {company.call}</p>
              <a
                href={company.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                🌐 홈페이지
              </a>
            </div>
          ))
        ) : (
          <p className={styles.noData}>등록된 회사가 없습니다.</p>
        )}
      </div>

      {isModalOpen && (
        <Modal
          message={`❗ ${selectedCompany?.name} 회사를 삭제하시겠습니까?`}
          onClose={() => setIsModalOpen(false)}
          onConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
};

export default CompanyList;
